export default __webpack_public_path__ + "static/media/arrow-up.002d7f04.svg";